import React, { useContext } from "react";
import styled from "@emotion/styled";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { ThemeContext } from "../../contexts/ThemeContext";
import MotionPhotosOffRoundedIcon from '@mui/icons-material/MotionPhotosOffRounded';
import AnimationRoundedIcon from '@mui/icons-material/AnimationRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import FadeIn from "../../utils/FadeIn";
import { recordEvent, Events } from "../../analytics";

const StyledSettings = styled.div`
    .MuiSpeedDial-fab {
        background-color: transparent;
        box-shadow: none;
        width: 50px;
        height: 50px;
        margin: 0.5em;
        color: var(--ex-primary-text-color);
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

        :hover {
            background-color: rgba(0,0,0,0.1);
            transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
        }
    }
`;


const Settings = () => {
    const { theme, changeTheme, reducedMotion, toggleReducedMotion, dashboardFs } = useContext(ThemeContext);

    // Hard coding due to issues with CSS variables
    const settingsIconColor = theme === "light" ? "#17375E" : "#DDE9F7";

    if (dashboardFs) {
        return null;
    }

    const analyticsCaptureClick = (setting, value) => {
        recordEvent(Events.SETTINGS_OPTION_CLICKED, {
            setting: setting,
            value: value
        });
    }

    return (
        <StyledSettings>
            <FadeIn stopMovement>
                <SpeedDial
                    ariaLabel="Settings"
                    sx={{
                        "position": "absolute",
                        "top": 0,
                        "right": 0,
                        // "opacity": dashboardFs ? 0 : 1,
                    }}
                    icon={<SpeedDialIcon icon={<SettingsRoundedIcon color={settingsIconColor} />} />}
                    direction="left"
                >
                    <SpeedDialAction
                        icon={theme === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
                        tooltipTitle={theme === 'light' ? "Turn off the lights" : "Turn on the lights"}
                        onClick={changeTheme}
                        onClickCapture={() => analyticsCaptureClick("theme", theme === 'light' ? 'dark' : 'light')}
                        sx={{
                            backgroundColor: theme === "light" ? "rgba(0,0,0,0.05)" : "rgba(255,255,255,0.1)",
                            border: "1px solid var(--border-color)",
                            boxShadow: "none",
                            color: "var(--ex-primary-text-color)",
                            transition: "all 0.2s ease-in-out",
                            ":focus": {
                                "boxShadow": "none"
                            },
                            ":hover": {
                                "backgroundColor": theme === "light" ? "rgba(0,0,0,0.15)" : "rgba(255,255,255,0.2)"
                            }
                        }}
                    />
                    <SpeedDialAction
                        icon={reducedMotion ? <AnimationRoundedIcon /> : <MotionPhotosOffRoundedIcon />}
                        tooltipTitle={reducedMotion ? "Enable Motion" : "Reduce Motion"}
                        onClick={toggleReducedMotion}
                        onClickCapture={() => analyticsCaptureClick("reducedMotion", !reducedMotion)}
                        sx={{
                            backgroundColor: theme === "light" ? "rgba(0,0,0,0.05)" : "rgba(255,255,255,0.1)",
                            border: "1px solid var(--border-color)",
                            boxShadow: "none",
                            color: "var(--ex-primary-text-color)",
                            transition: "all 0.2s ease-in-out",
                            ":focus": {
                                "boxShadow": "none"
                            },
                            ":hover": {
                                "backgroundColor": theme === "light" ? "rgba(0,0,0,0.15)" : "rgba(255,255,255,0.2)"
                            }
                        }}
                    />
                </SpeedDial>
            </FadeIn>
        </StyledSettings>
    )
}

export default Settings;